<template>
  <v-card class="shadowCard panel-resumen-semana">
    <v-card-text class="pa-4">
      <div class="panel-head">
        <div class="panel-kicker">
          <v-icon small color="indigo darken-1" class="mr-1">mdi-chart-box-outline</v-icon>
          Ventas por semana
        </div>
        <div class="panel-rango" v-if="fechaInicio || fechaFin">
          {{ fechaInicio || '—' }}
          <span class="mx-1">→</span>
          {{ fechaFin || '—' }}
        </div>
        <div class="panel-etiqueta" v-if="etiqueta">{{ etiqueta }}</div>
      </div>

      <v-row dense class="mt-1">
        <v-col cols="12" sm="6">
          <div class="metrica metrica--neutra">
            <div class="metrica-label">Semana ant.</div>
            <div class="metrica-valor">{{ semanaAntMostrada }}</div>
          </div>
        </v-col>
        <v-col cols="12" sm="6">
          <div
            class="metrica metrica--actual"
            :class="{ 'metrica--click': clickableSemanaAct }"
            @click="onClickSemanaAct"
          >
            <div class="metrica-label">
              Semana act.
              <v-icon v-if="delta > 0" x-small color="green darken-1">mdi-trending-up</v-icon>
              <v-icon v-else-if="delta < 0" x-small color="red darken-1">mdi-trending-down</v-icon>
            </div>
            <div class="metrica-valor">{{ semanaActMostrada }}</div>
            <div v-if="clickableSemanaAct" class="metrica-hint">Ver detalle</div>
          </div>
        </v-col>
      </v-row>

      <div v-if="$slots.footer" class="mt-4">
        <slot name="footer"></slot>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'PanelResumenSemana',

  props: {
    fechaInicio: { type: String, default: '' },
    fechaFin: { type: String, default: '' },
    etiqueta: { type: String, default: '' },
    semanaAnt: { default: 0 },
    semanaAct: { default: 0 },
    clickableSemanaAct: { type: Boolean, default: true },
  },

  computed: {
    semanaAntNum() {
      const n = Number(this.semanaAnt)
      return Number.isFinite(n) ? n : 0
    },
    semanaActNum() {
      const n = Number(this.semanaAct)
      return Number.isFinite(n) ? n : 0
    },
    semanaAntMostrada() {
      return String(this.semanaAntNum)
    },
    semanaActMostrada() {
      return String(this.semanaActNum)
    },
    delta() {
      return this.semanaActNum - this.semanaAntNum
    },
  },

  methods: {
    onClickSemanaAct() {
      if (!this.clickableSemanaAct) return
      this.$emit('click-semana-act')
    },
  },
}
</script>

<style scoped>
.panel-resumen-semana {
  height: 100%;
}

.panel-head {
  text-align: center;
  margin-bottom: 12px;
}

.panel-kicker {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1.1px;
  text-transform: uppercase;
  color: #3949ab;
}

.panel-rango {
  margin-top: 4px;
  font-size: 15px;
  font-weight: 700;
  color: #263238;
}

.panel-etiqueta {
  margin-top: 2px;
  font-size: 12px;
  color: #78909c;
}

.metrica {
  background: #f7f8fc;
  border: 1px solid #eef0f6;
  border-radius: 12px;
  padding: 12px 8px 14px;
  text-align: center;
  min-height: 92px;
}

.metrica--actual {
  background: #eef3ff;
  border-color: #d6e0ff;
}

.metrica--click {
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.metrica--click:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 16px rgba(57, 73, 171, 0.12);
}

.metrica-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: #607d8b;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.metrica-valor {
  font-size: 1.85rem;
  font-weight: 800;
  line-height: 1.1;
  color: #1a237e;
}

.metrica-hint {
  margin-top: 4px;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: #90a4ae;
}
</style>
